import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import de from '@/locales/de'
import Tag from '@/components/Tag'
import {createI18n} from 'vue-i18n/index'
import Config from './config/config'
import Tags from '@/components/Tags'
import Icon from '@/components/Icon'
import Answer from '@/components/Answer'
import Answers from '@/components/Answers'
import ProgressBar from '@/components/ProgressBar'
import Configurator from '@/components/Configurator'
import ComponentTypeMixin from './mixins/componentType'
import StartScreen from '@/components/componentTypes/StartScreen'
import ResultScreen from '@/components/componentTypes/ResultScreen'
import FeedbackScreen from '@/components/componentTypes/FeedbackScreen'
import QuestionScreen from '@/components/componentTypes/QuestionScreen'
import GreetingScreen from '@/components/componentTypes/GreetingScreen'
import ScrollableContent from '@/components/ScrollableContent'
import LoadingSpinner from '@/components/LoadingSpinner'
import Product from '@/components/Product'
import Color from '@/components/Color'
import Vue3TouchEvents from 'vue3-touch-events'

// Add Config to application
store.commit('setLevels', Config.levels)
store.commit('setAdvisor', Config.meta.advisor)
store.commit('setDisabledFullScreens', Config.meta.disabledFullScreens)

// Add translation plugin
const i18n = createI18n({
  locale: 'de',
  fallback: 'de',
  messages: {
    de
  }
})

createApp(App)
  .use(i18n)
  .use(store)
  .use(Vue3TouchEvents)
  .mixin(ComponentTypeMixin)
  .component('icon', Icon)
  .component('tag', Tag)
  .component('tags', Tags)
  .component('color', Color)
  .component('answer', Answer)
  .component('answers', Answers)
  .component('product', Product)
  .component('progress-bar', ProgressBar)
  .component('start-screen', StartScreen)
  .component('configurator', Configurator)
  .component('result-screen', ResultScreen)
  .component('question-screen', QuestionScreen)
  .component('greeting-screen', GreetingScreen)
  .component('feedback-screen', FeedbackScreen)
  .component('scrollable-content', ScrollableContent)
  .component('loading-spinner', LoadingSpinner)
  .mount('.pimcore_area_product-advisor')
